import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-top: -5px;
`

export const Option = styled.div`
  padding-top: 12px;
`

export const Label = styled.div`
  font-family: Roboto;
`

export const Title = styled.div`
  color: #363636;
  margin-bottom: 4px;
  font-weight: 500;
`

export const Subtitle = styled.div`
  color: #757575;
  font-weight: 400;
`
